export const navigations = [
    {
        id: 'ma-landing',
        title: 'Home',
        translate: 'HOME',
        type: 'item',
        url: '/home',
        icon: 'home',
        iconType: 'feather',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Schedule and Absences',
        translate: 'SCHEDULE_AND_ABSENCES',
        type: 'item',
        url: '/schedule',
        icon: 'calendar',
        iconType: 'feather',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Projects and Wishlists',
        translate: 'PROJECTS_AND_WISHLISTS',
        type: 'item',
        url: '/projects-wishlist',
        icon: 'file-text',
        iconType: 'feather',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Open Positions',
        translate: 'OPEN_POSITIONS',
        type: 'item',
        url: '/open-position',
        icon: 'user-check',
        iconType: 'feather',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Material',
        translate: 'MATERIAL',
        type: 'item',
        url: '/inventory',
        icon: 'clipboard',
        iconType: 'feather',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Chats',
        translate: 'CHATS',
        type: 'item',
        url: '/chats',
        iconType: 'feather',
        icon: 'message-square',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Quality Reports',
        translate: 'QUALITY_REPORTS',
        type: 'item',
        url: '/quality-reports',
        icon: 'menu',
        iconType: 'material',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Payroll',
        translate: 'PAYROLL',
        type: 'item',
        url: '/income-and-hours',
        icon: 'credit_card',
        isVisible: true,
        iconType: 'material'
    },
    {
        id: 'ma-landing',
        title: 'Announcement',
        translate: 'ANNOUNCEMENT',
        type: 'item',
        url: '/announcement',
        iconType: 'feather',
        isVisible: true,
        icon: 'bell'
    },
    {
        id: 'DMS-Common-Feature',
        title: 'My Documents',
        translate: 'MY_DOCUMENTS',
        type: 'item',
        url: '/my-documents',
        icon: 'folder',
        iconType: 'material',
        isVisible: true
    },
    {
        id: 'DMS-Common-Feature',
        title: 'Company Documents',
        translate: 'ORGANIZATIONAL_DOCUMENTS',
        type: 'item',
        url: '/organizational-documents',
        icon: 'folder',
        iconType: 'material',
        isVisible: true
    },
    {
        id: 'ma-landing',
        title: 'Logout',
        translate: 'LOGOUT',
        type: 'item',
        url: '/logout',
        icon: 'log-out',
        iconType: 'feather',
        isVisible: true
    }
];
